import { IFiltersTemplate } from '@/utils/interfaces/filtersTemplate'
import { ITypeOrmPaginationTemplate } from '@/utils/interfaces/typeormPagination'
import { IAddonsResponse } from '../services/types'

export enum actionTypes {
	GET_ADDONS = 'GET_ADDONS',
	GET_ADDON = 'GET_ADDON',
	CREATE_ADDON = 'CREATE_ADDON',
	CLONE_ADDON = 'CLONE_ADDON',
	UPDATE_ADDON = 'UPDATE_ADDON',
	DELETE_ADDON = 'DELETE_ADDON',
	UPDATE_ADDON_ACTIVE = 'UPDATE_ADDON_ACTIVE',
	SET_MODAL_CREATE_ADDONS = 'SET_MODAL_CREATE_ADDONS',
	CLEAR_ADDONS_SELECTED = 'CLEAR_ADDONS_SELECTED',

	SELECT_TAG = 'SELECT_TAG',
}

export type IAddonsFilters = IFiltersTemplate

export interface IAddonsState {
	addons: ITypeOrmPaginationTemplate<IAddonsResponse>
	selectedAddon: IAddonsResponse
	openModalCreateAddons: boolean
	openModalUpdateAddons: boolean
	addonIsLoading: boolean
	addonIsSaving: boolean
	filters: IAddonsFilters
}
